const KeyboardEventKey = {
	Enter: "Enter",
	Escape: "Escape",
	Backspace: "Backspace",
	Delete: "Delete",
} as const;

export { KeyboardEventKey };
